import { AUTH_URL } from 'src/constants/global'
import { useFetchCb } from '@gluedigital/ruse-fetch-extras'

export default function useAnalyticsProperty() {
  const doFetch = useFetchCb()
  const refresh = useFetchCb()

  const submitProperty = async (propertyId: string) => {
    return await doFetch(AUTH_URL + '/auth/property', {
      method: 'POST',
      body: { propertyId }
    })
  }

  const refreshProperty = async () => {
    return await refresh(AUTH_URL + '/auth/profile')
  }

  return { submitProperty, refreshProperty }
}
